export default __webpack_public_path__ + "static/media/settings.30d962a4.svg";